/* eslint-disable import/no-cycle */
import { Logger } from '@saviynt/common';

import { httpService } from '../../../http-service/httpService';
import { setCertsListActionStatus } from '../action';
import { SET_ACTIVE_TAB, SET_ALL_TABS_COUNT, SET_TAB_COUNT } from '../types';
import {
  URL_CERT_LIST_REFRESH_PROGRESS,
  URL_CERT_LIST_TABS_COUNT_API,
} from '../urls';

/**
 *
 * @param {object} tabsCount  - contains all tab counts
 *
 * @returns {function} A thunk that dispatches an action with type `SET_TAB_COUNT` and the `tabName` and `tabCount as payload.
 */
export const setTabsCount = (tabsCount) => (dispatch) => {
  dispatch({
    type: SET_ALL_TABS_COUNT,
    payload: tabsCount,
  });
};

/**
 * * @param {string} campaignKey - The unique identifier of the campaign.
 * @returns {Promise<void>} - A promise that resolves when the API call completes and the Redux store is updated.
 */
export const getCertListTabsCount = () => async (dispatch, getState) => {
  const {
    global: { campaignKey },
    core: {
      campaignInfo: { isCampaignOwner },
    },
  } = getState().certifications.list;

  try {
    const body = { isCampaignOwner };

    if (campaignKey) {
      body.campaignKey = campaignKey;
    }

    const { data } = await httpService.post(URL_CERT_LIST_TABS_COUNT_API, body);
    const { response, finalTabCount } = data;

    if (response === 'Success') {
      if (finalTabCount && Object.keys(finalTabCount).length > 0) {
        dispatch(setTabsCount(finalTabCount));
      }
    }

    return true;
  } catch (error) {
    Logger.log('Error: fetching getCertListTabsCount', error);

    return false;
  }
};

/**
 *
 * @param {string} activeTabName - active tab name
 * @returns {function} A thunk that dispatches an action with type `SET_ACTIVE_TAB` and the `activeTabName` as payload.
 */
export const setActiveTab = (activeTabName) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_TAB,
    payload: activeTabName,
  });
};

/**
 *
 * @param {string} tabName  - tab name
 * @param {number} tabCount - items count
 * @returns {function} A thunk that dispatches an action with type `SET_TAB_COUNT` and the `tabName` and `tabCount as payload.
 */
export const setTabCount = (tabName, tabCount) => (dispatch) => {
  dispatch({
    type: SET_TAB_COUNT,
    payload: {
      tabName,
      tabCount,
    },
  });
};

/**
 *
 * @returns {Promise<void>} - A promise that resolves when the API call completes and the Redux store is updated.
 */
export const refreshProgress = () => async (dispatch, getState) => {
  const {
    global: { campaignKey },
  } = getState().certifications.list;

  try {
    const body = {
      fromCertList: 'yes',
    };

    if (campaignKey) {
      body.campaignKey = campaignKey;
    }

    const { data } = await httpService.post(
      URL_CERT_LIST_REFRESH_PROGRESS,
      body
    );
    const { response } = data;

    if (typeof response === 'string') {
      dispatch(
        setCertsListActionStatus({
          action: 'REFRESH_PROGRESS',
          status: 'INFO',
          response,
        })
      );
    }

    return true;
  } catch (error) {
    Logger.log('Error: refreshProgress', error);
    dispatch(
      setCertsListActionStatus({
        action: 'REFRESH_PROGRESS',
        status: 'FAILED',
        response: 'Campaign job run failed, please try again.',
      })
    );

    return false;
  }
};
